import classNames from 'classnames';
import { ComponentProps } from 'react';
import styles from './NavBarBadge.module.scss';

export type NavBarBadgeProps = ComponentProps<'span'> & {
  skin?: 'blue' | 'purple' | 'grey';
};

const NavBarBadge = ({ className, skin = 'grey', ...props }: NavBarBadgeProps) => {
  return <span className={classNames(styles['badge'], styles[`badge-${skin}`], className)} data-badge {...props} />;
};

export default NavBarBadge;
